"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactElasticCarousel = _interopRequireWildcard(require("react-elastic-carousel"));
var _arrowRight = _interopRequireDefault(require("./arrow-right.svg"));
var _arrowLeft = _interopRequireDefault(require("./arrow-left.svg"));
var _sliderModule = _interopRequireDefault(require("./slider.module.scss"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ArcArrowSlider = function ArcArrowSlider(_ref) {
  var children = _ref.children,
    itemstoshow = _ref.itemstoshow,
    className = _ref.className,
    itemPadding = _ref.itemPadding,
    renderArrow = _ref.renderArrow,
    onResize = _ref.onResize,
    pagination = _ref.pagination,
    breakPoints = _ref.breakPoints;
  var imgs = renderArrow ? renderArrow : [_arrowLeft["default"], _arrowRight["default"]];
  var myArrow = function myArrow(_ref2) {
    var type = _ref2.type,
      onClick = _ref2.onClick,
      isEdge = _ref2.isEdge;
    var pointer = type === _reactElasticCarousel.consts.PREV ? /*#__PURE__*/_react["default"].createElement("img", {
      src: imgs[0],
      width: "12px",
      height: "12px"
    }) : /*#__PURE__*/_react["default"].createElement("img", {
      src: imgs[1],
      width: "12px",
      height: "12px"
    });
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _sliderModule["default"].arrowStyle
    }, /*#__PURE__*/_react["default"].createElement("button", {
      onClick: onClick,
      disabled: isEdge
    }, pointer));
  };
  return /*#__PURE__*/_react["default"].createElement(_reactElasticCarousel["default"], {
    itemsToShow: itemstoshow,
    className: className,
    renderArrow: myArrow,
    itemPadding: itemPadding,
    onResize: onResize,
    pagination: pagination,
    breakPoints: breakPoints
  }, children);
};
var _default = ArcArrowSlider;
exports["default"] = _default;